import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

/* ===================== IMAGES ===================== */

const uploadImg = async (formData) => {
  const response = await axios.post(
    `${base_url}upload/images`,
    formData,
    config // works because backend expects multipart
  );
  return response.data;
};

const deleteImg = async (id) => {
  const response = await axios.delete(
    `${base_url}upload/images/${id}`,
    config
  );
  return response.data;
};

/* ===================== VIDEO ===================== */

const uploadVideo = async (data) => {
  // `data` MUST be FormData
  const response = await axios.post(
    `${base_url}upload/video`, // 👈 single video endpoint
    data,
    config
  );
  return response.data;
};


const deleteVideo = async (id) => {
  const response = await axios.delete(
    `${base_url}upload/video/${id}`,
    config
  );
  return response.data;
};

/* ===================== EXPORT ===================== */

const uploadService = {
  uploadImg,
  deleteImg,
  uploadVideo,
  deleteVideo,
};

export default uploadService;
